import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
const logo = 'https://hefafnsdx7xk1nzg.public.blob.vercel-storage.com/corre_logo.PNG';
import { FaTwitter } from 'react-icons/fa';
import { logger } from '../utils/logger';

function LandingPage() {
  const { isAuthenticated, login, isLoading } = useAuth();
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    if (isAuthenticated) navigate('/dashboard');
  }, [isAuthenticated, navigate]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleNavLinkClick = () => {
    // Add logic here if clicking a nav link should do something specific
    // besides default anchor behavior, e.g., smooth scroll
    setIsMobileMenuOpen(false); // Close menu on link click
  };

  const handleGetStartedClick = () => {
    login();
    setIsMobileMenuOpen(false); // Close menu on action
  };

  return (
    <div className="landing-page">
      <div className="noise-overlay"></div>
      <header className="landing-header">
        <div className="logo" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <img 
            src={logo} 
            alt="Corre Logo" 
            style={{
              height: '40px',
              width: 'auto',
              objectFit: 'contain'
            }}
          />
          <h1 style={{
            margin: 0,
            color: '#333',
            fontSize: '2rem',
            fontWeight: 'bold',
            fontFamily: 'Inter, sans-serif'
          }}>Corre</h1>
        </div>
        <button className="landing-hamburger-menu hamburger-menu" onClick={toggleMobileMenu} aria-label="Toggle menu" aria-expanded={isMobileMenuOpen}>
          {isMobileMenuOpen ? '✕' : '☰'} {/* Unicode icons for close/hamburger */}
        </button>
        <nav className={"main-nav" + (isMobileMenuOpen ? " open" : "")}>
          <a href="#product-section" className="nav-link" onClick={handleNavLinkClick}>Product</a>
          <a href="#resources-section" className="nav-link" onClick={handleNavLinkClick}>Resources</a>
          <button className="get-started-btn" onClick={handleGetStartedClick}>
            {'Login'}
          </button>
        </nav>
      </header>

      <section className="hero">
        <div className="hero-content">
          <h1>Your gateway to global finance</h1>
          <p className="subtitle">Unlock seamless cross-border transactions and financial freedom with our innovative platform.</p>
          <button className="cta-button" onClick={login}>
            {'Get Started'}
          </button>
        </div>
        <div className="hero-image">
          <img src="https://hefafnsdx7xk1nzg.public.blob.vercel-storage.com/nfts/businessman-i0ksXzifM5SJQjbqmMKaYxPGszdv8m.jpg" alt="Global Finance Network" className="hero-illustration" style={{objectFit: 'cover', borderRadius: '20px', maxWidth: '100%', height: 'auto'}}/>
        </div>
      </section>

      <section className="features-section">
        <h2>Empowering financial freedom</h2>
        <p className="section-subtitle">Experience the future of borderless finance with our comprehensive suite of tools.</p>
        
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">
              <div className="icon-square">
                <span>📱</span>
              </div>
            </div>
            <h3>Receive Funds via Wallet Addresses</h3>
            <p>Get paid instantly with your unique wallet address from anywhere in the world.</p>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon">
              <div className="icon-circle">
                <span>💱</span>
              </div>
            </div>
            <h3>Seamless Off-Ramping</h3>
            <p>Convert your crypto to local currency and withdraw to your bank account with ease.</p>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon">
              <div className="icon-percent">
                <span>%</span>
              </div>
            </div>
            <h3>Earn DeFi Yields</h3>
            <p>Grow your assets by earning competitive yields on your stablecoin holdings.</p>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon">
              <div className="icon-percent" style={{ background: '#4F46E5' }}>
                <span>📈</span>
              </div>
            </div>
            <h3>Invest in Markets</h3>
            <p>Diversify your portfolio with stocks and government bonds. Grow your wealth with traditional and digital assets.</p>
          </div>
        </div>
      </section>

      <section className="testimonials">
        <h2>What our users say</h2>
        <div className="testimonial-grid">
          <div className="testimonial-card">
            <div className="testimonial-content">
              <p className="quote">"Game changer for my business. The platform is intuitive and the support team is amazing."</p>
              <div className="author">
                <div className="author-avatar">
                  <img src="https://randomuser.me/api/portraits/women/44.jpg" alt="Alex Johnson" />
                </div>
                <div className="author-info">
                  <h4>Alex Johnson</h4>
                  <p>Freelance Designer</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="testimonial-card">
            <div className="testimonial-content">
              <p className="quote">"Finally a solution that makes crypto payments simple and accessible for everyone."</p>
              <div className="author">
                <div className="author-avatar">
                  <img src="https://randomuser.me/api/portraits/men/32.jpg" alt="Sam Taylor" />
                </div>
                <div className="author-info">
                  <h4>Sam Taylor</h4>
                  <p>Digital Nomad</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="testimonial-card">
            <div className="testimonial-content">
              <p className="quote">"The best rates and lowest fees I've found. Highly recommended for freelancers!"</p>
              <div className="author">
                <div className="author-avatar">
                  <img src="https://randomuser.me/api/portraits/women/68.jpg" alt="Jordan Lee" />
                </div>
                <div className="author-info">
                  <h4>Jordan Lee</h4>
                  <p>Content Creator</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="security-section" style={{ backgroundColor: '#f3f4f6' }}>
        <div className="security-content">
          <h2>Security you can trust</h2>
          <p>Your funds are protected with bank-level security and multi-signature technology. We prioritize your privacy and security above all else.</p>
          <ul className="security-features">
            <li>Bank-grade encryption</li>
            <li>Multi-signature wallets</li>
            <li>2FA Authentication</li>
            <li>Regular security audits</li>
          </ul>
        </div>
      </section>

      <section className="cta-section" style={{ backgroundColor: '#f3f4f6' }}>
        <h2 style={{ color: '#111827' }}>Join Corre today</h2>
        <p style={{ color: '#4b5563' }}>Start your journey to financial freedom. Sign up now and get your first month free.</p>
        <button className="cta-button" onClick={login} style={{ 
          backgroundColor: '#4F46E5',
          color: 'white',
          border: 'none',
          padding: '0.75rem 2rem',
          borderRadius: '0.5rem',
          fontSize: '1rem',
          fontWeight: 600,
          cursor: 'pointer',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
        }}>
          {'Get Started'}
        </button>
      </section>

      <footer className="landing-footer" style={{ backgroundColor: '#111827' }}>
        <div className="footer-content">
          <div className="footer-logo">Corre</div>
          <div className="footer-links">
            <a href="#" className="footer-link">Privacy Policy</a>
            <a href="#" className="footer-link">Terms of Service</a>
            <a href="#" className="footer-link">Contact Us</a>
            <a 
              href="https://x.com/Corre_hq" 
              target="_blank" 
              rel="noopener noreferrer"
              className="footer-link"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.5rem',
                color: '#1DA1F2',
                textDecoration: 'none',
                marginLeft: '1rem'
              }}
            >
              <FaTwitter size={18} />
              <span>Follow us</span>
            </a>
          </div>
          <div className="copyright">© 2025 Corre. All rights reserved. <br /> In beta testing </div>
        </div>
      </footer>
    </div>
  );
}

export default LandingPage;